
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import {
  VisualHintDTO,
  QrCodeDTO,
  RequestedAction
} from "@moderrotech/servers-communication-library/src/types";
import _ from "lodash";
import Spinner from "@/components/Spinner.vue";
import {
  copyImageToClipboard,
  requestClipboardWritePermission
} from "copy-image-clipboard";
import { showToastError, showToastSuccess } from "@/helpers/notification";
import { i18n } from "@/lang";
import ProgressBar from "@/components/ProgressBar.vue";
import { useRafFn } from "@vueuse/core";
import { getUaParserResult } from "@moderrotech/servers-communication-library/src/helpers/device";
import { OSName } from "ua-parser-js/src/enums/ua-parser-enums";
/* eslint-disable */
// @ts-ignore
import { useQRCode } from '@vueuse/integrations/useQRCode.cjs'
/* eslint-enable */

export default {
  components: {
    ProgressBar,
    Spinner
  },
  setup() {
    const store = useStore();

    const visualHint = computed(
        (): VisualHintDTO | null => store.state.session.visualHint
      ),
      qrCode = computed((): QrCodeDTO | null => store.state.session.qrCode),
      duration = computed(
        () => (visualHint.value ?? qrCode.value)?.duration ?? null
      );

    const qrCodeUrl = useQRCode(qrCode.value?.text ?? "test bla", {
      width: 500
    });

    const unset = () => {
      store.commit("session/UNSET_VISUAL_HINT");
      store.commit("session/UNSET_QR_CODE");
    };

    const requestedRemoteActions = computed(
      (): { action: RequestedAction; payload?: any }[] | null =>
        store.state.session.requestedActions
    );

    const isPaused = ref(false);

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.pauseQrCode
        ),
      v => {
        if (v && qrCode.value) {
          isPaused.value = true;
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.pauseQrCode
          );
        }
      },
      { immediate: true }
    );

    const imgRef = ref<HTMLImageElement>();

    const width = ref<number | null>(null),
      height = ref<number | null>(null);

    useRafFn(() => {
      width.value = imgRef.value?.naturalWidth ?? null;
      height.value = imgRef.value?.naturalHeight ?? null;
    });

    const isCordova = !!store.state.config.config?.mobileAppData,
      isCopyButtonEnabled = ref<boolean>();

    onMounted(() => {
      if (isCordova || getUaParserResult()?.os.name !== OSName.IOS) {
        isCopyButtonEnabled.value = true;
        return;
      }
      requestClipboardWritePermission().then(
        hasPermission => (isCopyButtonEnabled.value = hasPermission)
      );
    });

    return {
      visualHint,
      qrCode,
      qrCodeUrl,
      duration,
      isPaused,
      imgRef,
      width,
      height,
      handleCopyClick: () =>
        copyImageToClipboard(visualHint.value?.url ?? qrCodeUrl.value)
          .then(() => showToastSuccess(i18n.global.t("call.success.imageCopy")))
          .catch((err: Error) => {
            console.error("Can not copy image: ", err);
            showToastError(i18n.global.t("call.error.imageCopy"));
          }),
      handleCloseClick: () => unset(),
      handleProgressEnd: () => unset(),
      isCopyButtonEnabled
    };
  }
};
